/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2022 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { xScreen } from "@stoneage/XDL/Utilities";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface ProductListColumnsStyles {
    wrapper?: InjectableCss;
    topRowWrapper?: InjectableCss;
    categoryTitleWrapper?: InjectableCss;
    categoryDescriptionWrapper?: InjectableCss;
    resultsCountWrapper?: InjectableCss;
}

export const columnsStyles: ProductListColumnsStyles = {
    wrapper: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: column;
            margin-bottom: 7px;
        `,
    },
    topRowWrapper: {
        css: css`
            display: flex;
            align-items: center;
            ${xScreen("lte", "sm")} {
                flex-direction: column;
                align-items: flex-start;
            }
        `,
    },
};

const styles = columnsStyles;

const ProductListColumns: FC<Props> = ({ id }) => (
    <StyledWrapper {...styles.wrapper}>
        <StyledWrapper {...styles.topRowWrapper}>
            <StyledWrapper {...styles.categoryTitleWrapper}>
                <Zone contentId={id} zoneName="CategoryTitle" />
            </StyledWrapper>
            <StyledWrapper {...styles.resultsCountWrapper}>
                <Zone contentId={id} zoneName="ResultsCount" />
            </StyledWrapper>
        </StyledWrapper>
        <StyledWrapper {...styles.categoryDescriptionWrapper}>
            <Zone contentId={id} zoneName="CategoryDescription" />
        </StyledWrapper>
        <StyledWrapper {...styles.categoryDescriptionWrapper}>
            <Zone contentId={id} zoneName="PaginationInfo" />
        </StyledWrapper>
    </StyledWrapper>
);

const widgetModule: WidgetModule = {
    component: ProductListColumns,
    definition: {
        group: "Category Details",
        displayName: "Header Container",
        allowedContexts: ["ProductListPage", "CategoryDetailsPage"],
    },
};

export default widgetModule;
